/* eslint-disable react/forbid-prop-types */
import {
  shape, string, arrayOf, number,
  oneOfType, objectOf, bool, object
} from 'prop-types';

export const metaDataItemShape = shape({
  id: oneOfType([string, number]),
  choiceId: oneOfType([string, number]),
  name: string,
  value: oneOfType([string, number]),
  metaDataType: oneOfType([string, number])
});

export const choiceShape = shape({
  id: oneOfType([string, number]),
  metaDataItems: arrayOf(metaDataItemShape),
  mediaUrl: string,
  shortLabel: string,
});

export const choicesArray = arrayOf(choiceShape);

export const optionShape = shape({
  id: oneOfType([string, number]),
  choices: arrayOf(oneOfType([string, number])),
  shortLabel: string,
  longLabel: string,
});

export const carouselBreakpointsShape = shape({
  sm: shape({
    slidesPerView: number,
    slidesPerGroup: number,
    spaceBetween: number,
  }),
  md: shape({
    slidesPerView: number,
    slidesPerGroup: number,
    spaceBetween: number,
  }),
  lg: shape({
    slidesPerView: number,
    slidesPerGroup: number,
    spaceBetween: number,
  }),
  xl: shape({
    slidesPerView: number,
    slidesPerGroup: number,
    spaceBetween: number,
  })
});

export const choiceMetadataShape = shape({
  GridSpan: string,
  ProductBasePaddingLeft: oneOfType([string, number]),
  ProductBaseWidth: oneOfType([string, number]),
  ProductStackHeight: oneOfType([string, number]),
  ProductType: string,
  Sku: oneOfType([string, number]),
  BundleDesign: string
});

export const choiceIdAndMetadataShape = shape({
  choiceId: oneOfType([string, number]),
  metadata: choiceMetadataShape
});

export const metadataShape = objectOf(choiceIdAndMetadataShape);

export const productIdentifiersShape = shape({
  itemId: string,
  isSuperSku: bool,
  parentId: string,
  canonicalUrl: string,
  brandName: string,
  modelNumber: string,
  productLabel: string,
  productType: string,
  storeSkuNumber: string,
  omsThdSku: string
});

export const productBadgesShape = arrayOf(shape({ name: string }));

export const productInfoShape = shape({
  classNumber: string,
  subClassNumber: string,
  productDepartment: string,
  quantityLimit: number
});

export const productMediaImageShape = shape({
  url: string,
  type: string,
  subType: string,
  sizes: arrayOf(string),
  altText: string
});

export const productMediaImagesArray = arrayOf(productMediaImageShape);

export const productMediaShape = shape({
  images: productMediaImagesArray
});

export const productDataShape = shape({
  itemId: string,
  identifiers: object,
  badges: arrayOf(object),
  info: object,
  media: object,
  pricing: object,
  specificationGroup: arrayOf(object),
  fulfillment: object,
  product: object
});

export const bundleDataShape = shape({
  id: string,
  products: arrayOf(object),
  bundleChoices: arrayOf(oneOfType([number, string])),
  bundleSkus: arrayOf(oneOfType([number, string]))
});
